/**
 * Finance Voucher Module Translations - English
 * Includes: Voucher Definition, Voucher Generation, Transfer Records, Subject Mapping
 */
export default {
  finance: {
    // ======== Voucher Definition ========
    voucherDef: {
      title: 'Voucher Definition',
      addVoucher: 'Add Voucher',
      editVoucher: 'Edit Voucher',
      name: 'Voucher Name',
      type: 'Voucher Type',
      typeJhd: 'Accounting Voucher',
      typePhd: 'Payment Voucher',
      erpType: 'ERP Type',
      erpTypeNc: 'Yonyou NC',
      erpTypeKingdee: 'Kingdee',
      erpTypeSap: 'SAP',
      status: 'Status',
      statusEnabled: 'Enabled',
      statusDisabled: 'Disabled',
      hSql: 'Header SQL',
      autoCast: 'Auto Transfer',
      castDay: 'Transfer Day',
      castHour: 'Transfer Hour',
      groupField: 'Group Upload Field',
      illustration: 'Description',
      remark: 'Remark',
      search: 'Search',
      reset: 'Reset',
      fetchFailed: 'Failed to fetch voucher list',
      addSuccess: 'Created successfully',
      editSuccess: 'Updated successfully',
      deleteConfirm: 'Are you sure to delete voucher "{name}"?',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      namePlaceholder: 'Enter voucher name',
      hSqlPlaceholder: 'Enter header SQL statement',
      illustrationPlaceholder: 'Enter voucher description',
      groupFieldPlaceholder: 'Leave empty for normal mode, fill with auxiliary account code for split',
    },

    // ======== Voucher Generation ========
    voucherGenerate: {
      title: 'Voucher Generation',
      subtitle: 'Preview and generate vouchers, upload to ERP',
      voucherTemplate: 'Voucher Template',
      voucherTemplatePlaceholder: 'Select voucher template',
      voucherDate: 'Voucher Date',
      voucherDatePlaceholder: 'Select voucher date',
      preview: 'Preview',
      generate: 'Generate',
      generateAndUpload: 'Generate & Upload',
      downloadXml: 'Download XML',
      uploadToErp: 'Upload to ERP',
      entryIndex: 'Index',
      subjectCode: 'Subject Code',
      subjectName: 'Subject Name',
      summary: 'Summary',
      debitAmount: 'Debit Amount',
      creditAmount: 'Credit Amount',
      totalDebit: 'Total Debit',
      totalCredit: 'Total Credit',
      uploadConfirmTitle: 'Confirm Upload to ERP',
      uploadConfirmMsg: 'Upload voucher to ERP? Total Debit: {debit}, Total Credit: {credit}. Confirm?',
      previewSuccess: 'Preview successful',
      previewFailed: 'Preview failed',
      generateSuccess: 'Voucher generated successfully',
      generateFailed: 'Failed to generate voucher',
      uploadSuccess: 'Upload successful',
      uploadFailed: 'Upload failed',
      noTemplate: 'Please select a voucher template first',
      noDate: 'Please select a voucher date first',
      duplicateWarning: 'A transfer record already exists for this voucher on the selected date. Continue?',
    },

    // ======== Voucher Record ========
    voucherRecord: {
      title: 'Transfer Records',
      subtitle: 'View voucher upload history to ERP',
      voucherName: 'Voucher Name',
      erpType: 'ERP Type',
      erpTypeNc: 'Yonyou NC',
      erpTypeKingdee: 'Kingdee',
      erpTypeSap: 'SAP',
      voucherDate: 'Voucher Date',
      dateRange: 'Date Range',
      dateStart: 'Start Date',
      dateEnd: 'End Date',
      status: 'Status',
      statusSuccess: 'Success',
      statusFailed: 'Failed',
      statusPreview: 'Preview',
      statusPartial: 'Partial',
      statusProcessing: 'Processing',
      voucherNo: 'Voucher No.',
      inputUser: 'Operator',
      inputDate: 'Input Date',
      errorMessage: 'Error Message',
      viewDetail: 'View Detail',
      reupload: 'Re-upload',
      reuploadConfirm: 'Are you sure to re-upload this voucher to ERP?',
      detailTitle: 'Transfer Record Detail',
      headerInfo: 'Header Info',
      entryDetail: 'Entry Details',
      uploadDetail: 'Upload Details (Grouped)',
      groupValue: 'Group Value',
      itemCount: 'Entry Count',
      erpVoucherNo: 'ERP Voucher No.',
      fetchFailed: 'Failed to fetch transfer records',
      reuploadSuccess: 'Re-upload successful',
      reuploadFailed: 'Re-upload failed',
      detailFailed: 'Failed to fetch detail',
    },

    // ======== Finance Subject Mapping ========
    financeSubject: {
      title: 'Subject Mapping',
      subtitle: 'Manage fee item to ERP subject mapping',
      addSubject: 'Add Mapping',
      editSubject: 'Edit Mapping',
      feeItemName: 'Fee Item Name',
      feeItemCode: 'Fee Item Code',
      feeItemSelect: 'Select fee item',
      erpType: 'ERP Type',
      erpTypeNc: 'Yonyou NC',
      erpTypeKingdee: 'Kingdee',
      erpTypeSap: 'SAP',
      erpTypePlaceholder: 'Select ERP type',
      subjectCode: 'Subject Code',
      subjectCodePlaceholder: 'Enter subject code',
      subjectName: 'Subject Name',
      subjectNamePlaceholder: 'Enter subject name',
      supplierName: 'Supplier',
      supplierCode: 'Supplier Code',
      channelName: 'Store',
      signCompanyName: 'Billing Entity',
      remark: 'Remark',
      fetchFailed: 'Failed to fetch subject list',
      addSuccess: 'Created successfully',
      editSuccess: 'Updated successfully',
      deleteConfirm: 'Are you sure to delete this subject mapping?',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
    },
  },
}
